import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from './apiClient';

const stockTransferKeys = {
  all: ['stockTransfers'],
  lists: () => [...stockTransferKeys.all, 'list'],
  list: (status) => [...stockTransferKeys.lists(), status || 'all'],
  details: () => [...stockTransferKeys.all, 'detail'],
  detail: (id) => [...stockTransferKeys.details(), id],
};

export const useStockTransfers = (status, options = {}) => {
  return useQuery({
    queryKey: stockTransferKeys.list(status),
    queryFn: async () => {
      const params = status ? { status } : undefined;
      const response = await apiClient.get('stock_transfers', { params });
      return response.data;
    },
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    ...options,
  });
};

export const useStockTransfer = (id, options = {}) => {
  return useQuery({
    queryKey: stockTransferKeys.detail(id),
    queryFn: async () => {
      const response = await apiClient.get(`stock_transfers/${id}`);
      return response.data;
    },
    enabled: !!id,
    staleTime: 30 * 1000,
    ...options,
  });
};

export const useReceiveStockTransfer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }) => {
      const response = await apiClient.post(`stock_transfers/${id}/receive`, data);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: stockTransferKeys.lists() });
      queryClient.invalidateQueries({ queryKey: stockTransferKeys.detail(variables.id) });
      queryClient.invalidateQueries({ queryKey: ['externalOrders'] });
    },
    onError: (error) => {
      console.error('Error receiving stock transfer:', error);
    },
  });
};
